const AboutDetails = () => {
    return (
        <div className="about-details">
            <div className="title">About</div>
            <div className="content">
                <div>Thank you for using the Summoning Match Maker tool!</div>
                <div>Your feedback is appreciated. Join the discord server to leave your feedback.</div>
                <div className="discord-link">
                    <a href="https://discord.com/invite/G9aHq2uXtq" target="_blank" rel="noreferrer">Next DFK Hero community on discord</a>
                </div>
                <div className="credits-section">
                    <div className="credit">
                        <div className="tool-name">Next DFK Hero</div>
                        <div className="created-by-text">created and maintained by</div>
                        <div className="discord-user">
                            <img className="discord-image" src="/discord.jpg" alt="Discord User" />
                            <div className="discord-username">Coolio#9272</div>
                        </div>
                    </div>
                    <div className="credit">
                        <div className="tool-name">Summoning Match Maker</div>
                        <div className="created-by-text">created and maintained by</div>
                        <div className="discord-user">
                            <img className="discord-image" src="/discord.jpg" alt="Discord User" />
                            <div className="discord-username">cicles#4351</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutDetails
